<template>
  <a-layout class="myApplication">
    <a-card :bordered="false">
      <search-form :search-conditions="searchConditions" :show-advanced="showAdvanced" :query-params="queryParams" @query="query" @update-option="fetchOptList" @update-params="updateParams"></search-form>
      <a-table :columns="columns" :rowKey="record => record.apply_number || record.id" :dataSource="dataSource" :pagination="false" :customRow="customRow" :loading="loading">
        <template slot="titleRender" slot-scope="text, record">
          <span>{{record.user_name}}提交的{{record.apply_type}}</span>
        </template>

        <template slot="abstractRender" slot-scope="text, record">
          <p v-if="record.form_type===7">申请类型：采购申请</p>
          <p v-else-if="record.form_type===6">申请类型：{{record.apply_detail_type}}</p>
          <div v-else>
            <p>{{record.apply_type}}类型：{{record.apply_detail_type}}</p>
            <p v-if="record.payee_name">收款方：{{record.payee_name}}</p>
            <p v-if="record.form_type!==6">{{record.apply_type}}总金额（{{record.money_type}}）：{{record.total_pay}}</p>
          </div>
        </template>
        <template slot="footer" slot-scope="currentPageData" v-if="dataSource.length<total">
          <p style="text-align:center">
            <span @click="loadMore" style="cursor:pointer">加载更多数据</span>
          </p>
        </template>
      </a-table>
    </a-card>
  </a-layout>
</template>

<script>
import moment from "moment";
import SearchForm from "../../components/SearchForm.vue";
import { getList } from "../../services/WaitApprovalListService";

import {
  ApplyTypeUrl,
  getSearchOptions,
  ApplyPersonUrl
} from "../../services/CommonService.js";

export default {
  components: {
    SearchForm
  },
  data() {
    return {
      showAdvanced: false,
      breadcrumb: [
        {
          label: "待我审批",
          path: ""
        }
      ],
      cardHeight: 0,
      loading: true,
      searchConditions: [
        [
          {
            label: "申请类型",
            type: "select",
            field: "applyType",
            placeholder: "请选择",
            fetch: {
              url: ApplyTypeUrl,
              params: {}
            },
            options: [],
            hasAll: true,
            triggerField: "applierId"
          },
          {
            label: "申请人",
            type: "complexSelect",
            field: "applierId",
            placeholder: "请选择",
            fetch: {
              url: ApplyPersonUrl,
              params: {
                apply_type: "all"
              }
            },
            options: []
          },
          {
            show: true,
            type: "btnGroup"
          }
        ],
        [
          {
            label: "提交审批时间",
            type: "range",
            field: "applyTime"
          },
          {
            show: false,
            type: "btnGroup"
          }
        ]
      ],
      columns: [
        {
          title: "申请标题",
          dataIndex: "title",
          width: 150,
          scopedSlots: { customRender: "titleRender" }
        },
        {
          title: "申请摘要",
          dataIndex: "abstract",
          width: 250,
          scopedSlots: { customRender: "abstractRender" }
        },
        {
          title: "发起时间",
          dataIndex: "apply_time",
          width: 150
        }
      ],
      dataSource: [],
      total: 0,
      queryParams: {
        applierId: undefined,
        applyType: undefined,
        currentPage: 1,
        pageSize: 20,
        filter: "waiting_for_me",
        applyTime: []
      },
      defaultApplyType: undefined
    };
  },

  created() {
    if (this.$route.query && this.$route.query.apply_type) {
      this.defaultApplyType = Number(this.$route.query.apply_type);
    }
    this.queryParams.applyType = this.defaultApplyType
      ? this.defaultApplyType
      : "all";
    this.queryParamsInit = _.cloneDeep(this.queryParams);
    // 是否有本地缓存参数
    const queryParams = JSON.parse(window.localStorage.getItem("queryParams"));
    if (queryParams && queryParams.applyType) {
      this.queryParams.applyType = queryParams.applyType;
    }
    if (queryParams && queryParams.applierId) {
      this.queryParams.applierId = queryParams.applierId;
    }
    if (
      queryParams &&
      queryParams.applyTime &&
      queryParams.applyTime.length > 0
    ) {
      this.queryParams.applyTime = queryParams.applyTime;
      this.showAdvanced = true;
    }
    this.cardHeight = document.documentElement.clientHeight - 150;
    const vm = this;
    window.onresize = function() {
      vm.cardHeight = document.documentElement.clientHeight - 150;
    };
    this.getList();
    this.searchConditions.forEach(item => {
      item.forEach(child => {
        if (child.fetch && child.fetch.url) {
          this.fetchOptList(child);
        }
      });
    });
  },

  computed: {
    queryObj() {
      return {
        current_page: this.queryParams.currentPage,
        page_size: this.queryParams.pageSize,
        filter: this.queryParams.filter,

        applier_id: this.queryParams.applierId,
        apply_type:
          this.queryParams.applyType === "all"
            ? undefined
            : this.queryParams.applyType,
        apply_time_start: this.queryParams.applyTime[0],
        apply_time_end: this.queryParams.applyTime[1]
      };
    }
  },

  mounted() {
   
  },

  methods: {
    fetchOptList(config) {
      config.loading = true;
      if (config.field === "applierId") {
        config.fetch.params.apply_type =
          this.queryParams.applyType === "all"
            ? undefined
            : this.queryParams.applyType;
      }
      getSearchOptions(config.fetch.url, config.fetch.params).then(res => {
        if (res.status === "success") {
          config.options = res.data;
          if (config.hasAll) {
            config.options.unshift({
              id: "all",
              name: "全部"
            });
          }
        } else {
          this.$Message.error(res.message);
        }
        config.loading = false;
      });
    },

    updateParams(e) {
      const key = Object.keys(e)[0];
      this.queryParams[key] = e[key];
    },

    query(e) {
      this.queryParams = _.cloneDeep(this.queryParamsInit);
      Object.assign(this.queryParams, e);
      this.dataSource = [];
      this.getList();
      window.localStorage.setItem(
        "queryParams",
        JSON.stringify(this.queryParams)
      );
    },

    getList() {
      this.loading = true;
      getList(this.queryObj).then(res => {
        if ((res.status = "success")) {
          this.total = res.total;
          this.dataSource = this.dataSource.concat(res.data);
        } else {
          this.$Message.error(res.message);
        }
        this.loading = false;
      });
    },

    loadMore() {
      this.queryParams.currentPage++;
      this.getList();
    },

    customRow(record) {
      let vm = this;
      return {
        on: {
          click(event) {
            if (record.form_type === 1)
              vm.$router.replace({
                name: "waitApprovalDetail",
                query: {
                  id: record.id
                }
              });
             
            if (record.form_type === 2)
              vm.$router.replace({
                name: "waitReimbursementDetail",
                query: {
                  id: record.id,
                }
              });
            if (record.form_type === 7)
              vm.$router.replace({
                name: "waitPurchaseDetail",
                query: {
                  id: record.id,
                }
              });
            if (record.form_type === 6) {
              vm.$router.replace({
                name: "waitBudgetApplicationDetail",
                query: {
                  id: record.id,
                }
              });
            }
            if (record.form_type === 8)
              vm.$router.replace({
                name: "waitProExpendPaymentDetail",
                query: {
                  id: record.id,
                }
              });
            if (record.form_type === 9)
              vm.$router.replace({
                name: "waitProExpendReimbursementDetail",
                query: {
                  id: record.id,
                }
              });
          }
        }
      };
    }
  }
};
</script>

<style lang="less">
.oa-app .myApplication {
  padding: 16px;
}
.dd-oa-app .myApplication {
  padding: 0;
  > .ant-card > .ant-card-body {
    padding: 24px 0;
  }
  .ant-advanced-search-form {
    padding: 0 32px;
  }
}
</style>
